const contractTemplates = [
  {
    title: 'Collaboration Agreement Template',
    description:
      "If you're working with another person or business, or collaboration agreement can help outline what to expect.",
    slug: 'legal-templates/collaboration-agreement',
    premium: true,
    categories: ['Legal Contracts', 'Hiring & People', 'Partnerships'],
    image: 'collaboration-agreement-template.png',
  },

  {
    title: 'Independent Contractor Agreement Template',
    description:
      'If you’re hiring an independent contractor, don’t be left without a contract.',
    slug: 'legal-templates/independent-contractor-agreement',
    premium: false,
    categories: ['Legal Contracts', 'Hiring & People', 'Partnerships'],
    image: 'independent-contractor-agreement-template.png',
  },

  {
    title: 'Joint Venture Agreement Template',
    description:
      'A joint venture agreement can help you establish the terms and details of a business relationship.',
    slug: 'legal-templates/joint-venture-agreement',
    premium: true,
    categories: ['Legal Contracts', 'Hiring & People', 'Partnerships'],
    image: 'joint-venture-agreement-template.png',
  },

  {
    title: 'Sales Agreement Contract Template',
    description:
      'A sales agreement is needed when selling goods or services. Learn all the details of what goes into a strong agreement.',
    slug: 'legal-templates/sales-agreement',
    premium: true,
    categories: ['Business Sales', 'Legal Contracts', 'Transactions'],
    image: 'sales-agreement-contract-template.png',
  },

  {
    title: 'Website Linking Agreement Template',
    description:
      'In certain situations, you may need a website linking agreement when linking to another website. Find out more and use our free template.',
    slug: 'legal-templates/website-linking-agreement',
    premium: false,
    categories: ['Business Protection', 'Website'],
    image: 'website-linking-agreement-template.png',
  },

  {
    title: '83 (b) Election Form',
    description: '83 (b) Election Form',
    slug: '83b-election-form-template',
    premium: true,
    categories: ['Business Tax'],
    image: '83b-election-form-template.png',
  },

  {
    title: 'Bill of Sale Template',
    description:
      'Whether you’re buying or selling, a bill of sale will protect both the buyer and seller.',
    slug: 'bill-of-sale-template',
    premium: false,
    categories: ['Business Sales', 'Transactions'],
    image: 'bill-of-sale-template.png',
  },

  {
    title: 'Consulting Agreement Template',
    description:
      'A consulting agreement is essential for both clients and consultants to properly define the scope of work and protect each party.',
    slug: 'consulting-agreement-template',
    premium: false,
    categories: ['Legal Contracts', 'Hiring & People', 'Partnerships'],
    image: 'consulting-agreement-template.png',
  },

  {
    title: 'General Corporate Resolution',
    description:
      'A general corporate resolution helps your company detail important corporate actions.',
    slug: 'corporate-resolution-template',
    premium: true,
    categories: ['Business Operations', 'Business Logistics'],
    image: 'general-corporate-resolution-template.png',
  },

  {
    title: 'Demand Letter Template',
    description:
      'A demand letter is a formal invitation for open discussion and dispute resolution between you and someone you are demanding something from.',
    slug: 'demand-letter-template',
    premium: true,
    categories: ['Disputes'],
    image: 'demand-letter-template.png',
  },

  {
    title: 'Employee Termination Letter Template',
    description:
      'Be sure you’re following the law by using an employee termination letter.',
    slug: 'employee-termination-letter-template',
    premium: true,
    categories: ['Annual Report', 'Branding', 'Employee Forms'],
    image: 'employee-termination-letter-template.png',
  },

  {
    title: 'Employment Agreement Template',
    description:
      'If you’re hiring employees, an employment agreement will be essential.',
    slug: 'employment-agreement-template',
    premium: true,
    categories: ['Employee Forms'],
    image: 'employment-agreement-template.png',
  },

  {
    title: 'Employment Offer Letter Template',
    description:
      'An employment offer letter is one of the first steps in bringing a new employee on board.',
    slug: 'employment-offer-letter-template',
    premium: true,
    categories: ['Hiring & People', 'Employee Forms'],
    image: 'employment-offer-letter-template.png',
  },

  {
    title: 'Founder Agreement Template',
    description:
      'You need protection for your small business and a founder agreement will outline the rights of the founder.',
    slug: 'founder-agreement',
    premium: true,
    categories: ['Hiring & People'],
    image: 'founder-agreement-template.png',
  },

  {
    title: 'Letter of Intent Template',
    description:
      'Ready to work with partners? A letter of intent will help you inform partners of your intention to do business.',
    slug: 'letter-of-intent-template',
    premium: true,
    categories: ['Hiring & People'],
    image: 'letter-of-intent-template.png',
  },

  {
    title: 'LLC Operating Agreement Template',
    description:
      'An LLC operating agreement for LLCs helps outline your business operations and sets a course for the future.',
    slug: 'llc-operating-agreement-template',
    premium: true,
    categories: ['Operating Agreement', 'Business Operations'],
    image: 'llc-operating-agreement-template.png',
  },

  {
    title: 'Memorandum of Understanding Template',
    description:
      'As a formal agreement between parties, a memorandum of understanding is used when working with others.',
    slug: 'memorandum-of-understanding-template',
    premium: true,
    categories: ['Hiring & People', 'Partnerships'],
    image: 'memorandum-of-understanding-template.png',
  },

  {
    title: 'Non-Disclosure Agreement Template',
    description:
      'You’ve likely heard of a non-disclosure agreement, or NDA. Learn all the details.',
    slug: 'non-disclosure-agreement-template',
    premium: true,
    categories: ['Legal Contracts', 'Intellectual Property'],
    image: 'non-disclosure-agreement-template.png',
  },

  {
    title: 'Free Organization Meeting Minutes Template',
    description:
      'Recording meeting minutes can be a vital part of your business operations. A meeting minutes template can make the process easy.',
    slug: 'organization-meeting-minutes-template',
    premium: false,
    categories: ['Business Logistics', 'Business Operations'],
    image: 'organization-meeting-minutes-template.png',
  },

  {
    title: 'Partnership Agreement Template',
    description:
      'A partnership agreement is a contract between two or more business partners and is used to outline the responsibilities and rights of each.',
    slug: 'partnership-agreement-template',
    premium: false,
    categories: ['Hiring & People', 'Partnerships'],
    image: 'partnership-agreement-template.png',
  },

  {
    title: 'Privacy Policy Template',
    description:
      'A privacy policy outlines how a company handles customers’ personal information when visiting its website.',
    slug: 'privacy-policy-template',
    premium: false,
    categories: ['Website'],
    image: 'privacy-policy-template.png',
  },

  {
    title: 'Release of Liability Form',
    description:
      'A release of liability waiver protects you and your business, as well as your relationships with your clients and business partners.',
    slug: 'release-of-liability-form',
    premium: true,
    categories: ['Partnerships', 'Hiring & People'],
    image: 'release-of-liability-form-template.png',
  },

  {
    title: 'Service Agreement Template',
    description:
      'A service agreement is a legal contract between parties to ensure terms and conditions are understood and agreed to.',
    slug: 'service-agreement-template',
    premium: false,
    categories: ['Hiring & People'],
    image: 'service-agreement-template.png',
  },

  {
    title: 'Terms of Service Agreement Template',
    description:
      'A terms of service agreement, or TOS, is commonly seen on many websites. Determine if your website needs one.',
    slug: 'terms-of-service-agreement-template',
    premium: false,
    categories: ['Website'],
    image: 'terms-of-service-agreement-template.png',
  },
];
export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('ContractTemplatesLibrary', () => {
        const plansFilter = {
          free: 0,
          premium: 0,
        };
        contractTemplates.forEach((template) => {
          if (template.premium) {
            plansFilter.premium += 1;
          } else {
            plansFilter.free += 1;
          }
        });
        const categories = contractTemplates.reduce((acc, template) => {
          template.categories.forEach((category) => {
            acc.push(category);
          });
          return acc;
        }, []);

        const categoriesFilter = {};

        categories.forEach((category) => {
          if (categoriesFilter[category]) {
            categoriesFilter[category] += 1;
          } else {
            categoriesFilter[category] = 1;
          }
        });

        return {
          templates: contractTemplates,
          filters: {
            plan: plansFilter,
            categories: categoriesFilter,
          },
          selectedFilters: {
            plan: [],
            category: [],
          },
          isExpanded: true,
          toggleFiltersExpanded() {
            this.isExpanded = !this.isExpanded;
          },
          onSelectFilter: function (filterType, filterValue) {
            let filteredTemplates = [];

            if (this.selectedFilters[filterType].includes(filterValue)) {
              this.selectedFilters[filterType] = this.selectedFilters[
                filterType
              ].filter((value) => value !== filterValue);
            } else {
              this.selectedFilters[filterType].push(filterValue);
            }

            if (this.selectedFilters.plan.length === 0) {
              filteredTemplates = contractTemplates;
            } else {
              this.selectedFilters.plan.forEach((plan) => {
                filteredTemplates = [
                  ...filteredTemplates,
                  ...contractTemplates.filter((template) => {
                    if (plan === 'free') {
                      return !template.premium;
                    }

                    return template.premium;
                  }),
                ];
              });
            }

            filteredTemplates = filteredTemplates.filter((template) => {
              if (this.selectedFilters.category.length === 0) {
                return true;
              }
              return this.selectedFilters.category.some((category) =>
                template.categories.includes(category),
              );
            });

            this.templates = filteredTemplates;
          },
        };
      });
    });
  },
};
